import React, {useState, useEffect} from 'react'
import {Modal, Button, Form} from 'react-bootstrap'
import {useIntl} from 'react-intl'

interface QuantityInputModalProps {
  show: boolean
  orderedQuantity: number // Add prop for the total ordered quantity
  onHide: () => void
  onSubmit: (quantity: number) => void
}

const QuantityInputModal: React.FC<QuantityInputModalProps> = ({show, orderedQuantity, onHide, onSubmit}) => {
  const [quantity, setQuantity] = useState<string>('')
  const [error, setError] = useState<string>('')
  const {formatMessage} = useIntl()

  // Reset state when modal is shown or hidden
  useEffect(() => {
    if (!show) {
      setQuantity('')
      setError('')
    }
  }, [show])

  const handleSubmit = () => {
    const numQuantity = parseInt(quantity, 10)
    // Basic validation: must be a positive number
    if (isNaN(numQuantity) || numQuantity <= 0) {
      setError(formatMessage({id: 'ORDERED_PRODUCTS.INVALID_QUANTITY'}))
      return
    }
    // New validation: must be less than ordered quantity
    if (numQuantity >= orderedQuantity) {
       setError(formatMessage({ id: 'ORDERED_PRODUCTS.QUANTITY_EXCEEDS_ORDERED' }, { orderedQuantity }));
      return;
    }
    setError('')
    onSubmit(numQuantity)
    // onHide() // Let the parent component handle hiding after successful submission if needed
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuantity(e.target.value)
    if (error) {
      setError('') // Clear error when user starts typing
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{formatMessage({id: 'ORDERED_PRODUCTS.ENTER_AVAILABLE_QUANTITY'})}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId='formAvailableQuantity'>
          <Form.Label>{formatMessage({id: 'ORDERED_PRODUCTS.QUANTITY'})}</Form.Label>
          <Form.Control
            type='number'
            placeholder={formatMessage({id: 'ORDERED_PRODUCTS.QUANTITY'})}
            value={quantity}
            onChange={handleInputChange}
            isInvalid={!!error}
            min='1'
            autoFocus // Focus the input when modal opens
          />
          <Form.Control.Feedback type='invalid'>{error}</Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          {formatMessage({id: 'cancel'})} {/* Assuming 'cancel' key exists */}
        </Button>
        <Button variant='primary' onClick={handleSubmit}>
          {formatMessage({id: 'submit'})} {/* Assuming 'submit' key exists */}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default QuantityInputModal
